import { Routes } from '@angular/router';

import { AuthService } from '../auth/auth.service';

import { ViewViewerInsightExplorerComponent } from './view-viewer.ie.component';

export const InsightExplorerRoutes: Routes = [
    {
        path: 'insight-explorer',
        component: ViewViewerInsightExplorerComponent,
        canActivate: [AuthService],
    },
];
